/* WILLI — liga a variante selecionada a foto certa da galeria.
   Bloco isolado: nao altera nada do tema, so LE o #product-variants-json que ja
   existe e rola o #gallery-track ate o slide cuja imagem e a featured_image da
   variante. Nao depende das classes de "selecionado" do tema (elas sao aplicadas
   por JS proprio dele); mantem o estado da selecao por conta propria. */
(function () {
  'use strict';
  if (location.pathname.indexOf('/products/') === -1) return;

  /* ── tipografia da descricao ──────────────────────────────────────────
     O tema marca a descricao com as classes `prose prose-sm` do Tailwind
     Typography, mas o plugin nao esta carregado — por isso h3/ul/table saem
     sem espacamento nenhum, tudo colado. Este bloco cobre so isso, e so na
     pagina de produto. */
  function tipografia() {
    if (document.getElementById('willi-prose-css')) return;
    var css = [
      '.prose{color:inherit}',
      '.prose > p{margin:0 0 .9em}',
      '.prose > p:last-child{margin-bottom:0}',
      '.prose h3{margin:1.9em 0 .7em;font-size:.72rem;font-weight:600;letter-spacing:.18em;',
      '  text-transform:uppercase;color:rgb(24 24 27);line-height:1.4}',
      '.prose h3:first-child{margin-top:.4em}',
      '.prose ul{margin:.6em 0 1.1em;padding-left:1.15em;list-style:disc}',
      '.prose ul li{margin:.4em 0;padding-left:.15em}',
      '.prose ul li::marker{color:rgb(24 24 27 / .35)}',
      '.prose strong{color:rgb(24 24 27);font-weight:600}',
      '.prose table{width:100%;border-collapse:collapse;margin:.6em 0 1.1em;font-size:.94em}',
      '.prose thead th{text-align:left;font-weight:600;color:rgb(24 24 27);',
      '  padding:.55em .9em .55em 0;border-bottom:1px solid rgb(24 24 27 / .18);white-space:nowrap}',
      '.prose tbody td{padding:.5em .9em .5em 0;border-bottom:1px solid rgb(24 24 27 / .07);',
      '  vertical-align:top}',
      '.prose tbody tr:last-child td{border-bottom:0}',
      '.prose table td:first-child{font-weight:500;color:rgb(24 24 27)}',
      '.prose em{display:block;margin:.2em 0 0;font-style:italic;opacity:.8;line-height:1.6}',
      '@media (max-width:520px){.prose table{font-size:.86em}',
      '  .prose thead th,.prose tbody td{padding-right:.5em}}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'willi-prose-css';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function init() {
    tipografia();
    var json = document.getElementById('product-variants-json');
    var track = document.getElementById('gallery-track');
    if (!json || !track) return;

    var variants;
    try { variants = JSON.parse(json.textContent || json.innerHTML); } catch (e) { return; }
    if (!variants || !variants.length) return;

    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(
      document.querySelectorAll('#gallery-thumbs .gallery-thumb'));

    function imgIdOf(slide) {
      var img = slide.querySelector('img[data-image-id]');
      return img ? String(img.getAttribute('data-image-id')) : null;
    }

    /* estado inicial: ?variant= na URL, senao a primeira variante disponivel */
    var inicial = null;
    try {
      var q = new URL(location.href).searchParams.get('variant');
      if (q) inicial = variants.filter(function (v) { return String(v.id) === String(q); })[0];
    } catch (e) {}
    if (!inicial) {
      inicial = variants.filter(function (v) { return v.available; })[0] || variants[0];
    }
    var sel = { 1: inicial.option1, 2: inicial.option2, 3: inicial.option3 };

    function variantAtual() {
      var exatas = variants.filter(function (v) {
        return v.option1 === sel[1] &&
               (sel[2] == null || v.option2 === sel[2]) &&
               (sel[3] == null || v.option3 === sel[3]);
      });
      /* se a combinacao nao existir, cai para a primeira do mesmo tamanho */
      return exatas[0] || variants.filter(function (v) { return v.option1 === sel[1]; })[0];
    }

    function mostrar(suave) {
      var v = variantAtual();
      if (!v || !v.featured_image) return;
      var alvo = String(v.featured_image.id);
      for (var i = 0; i < slides.length; i++) {
        if (imgIdOf(slides[i]) !== alvo) continue;
        var x = slides[i].offsetLeft - track.offsetLeft;
        if (track.scrollTo) track.scrollTo({ left: x, behavior: suave ? 'smooth' : 'auto' });
        else track.scrollLeft = x;
        for (var j = 0; j < thumbs.length; j++) {
          thumbs[j].classList.toggle('border-ink', j === i);
          thumbs[j].classList.toggle('border-transparent', j !== i);
        }
        return;
      }
    }

    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('.variant-option') : null;
      if (!b) return;
      var pos = b.getAttribute('data-option-position');
      var val = b.getAttribute('data-option-value');
      if (!pos || val == null) return;
      sel[pos] = val;
      /* espera o tema aplicar a propria selecao antes de rolar */
      setTimeout(function () { mostrar(true); }, 60);
    }, true);

    /* o proprio JS da galeria do tema inicializa depois e reseta a thumb ativa,
       entao reaplicamos algumas vezes ate ele terminar. */
    mostrar(false);
    [120, 400, 900, 1600].forEach(function (t) { setTimeout(function () { mostrar(false); }, t); });
  }

  /* o CSS entra imediatamente (nao espera o load) para nao piscar sem estilo */
  if (document.head) tipografia();
  else document.addEventListener('DOMContentLoaded', tipografia);

  function boot() {
    /* a parte da galeria roda depois do load, para vencer a inicializacao do tema */
    setTimeout(init, 60);
  }
  if (document.readyState === 'complete') boot();
  else window.addEventListener('load', boot);
})();
